import React from "react";
import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";
import { Link } from "react-router-dom";
import { useCreatePath, useRecordContext, useTranslate } from "react-admin";

type Props = {
  resource: string;
  label?: string;
  icon?: React.ReactElement;
};

export const MobileEditButton = ({ resource, label = "ra.action.edit", icon = <EditIcon /> }: Props) => {
  const record = useRecordContext();
  const createPath = useCreatePath();
  const translate = useTranslate();

  if (!record) {
    return null;
  }

  return (
    <Button component={Link} to={createPath({ type: "edit", resource, id: record.id })} size="small" startIcon={icon}>
      {translate(label, { _: label })}
    </Button>
  );
};
